import { ResizeObserver as t } from "./ghl-ui.es1250.js";
import "./ghl-ui.es1251.js";
class i {
  constructor() {
    this.handleResize = this.handleResize.bind(this), this.observer = new (typeof window < "u" && window.ResizeObserver || t)(this.handleResize), this.elHandlersMap = /* @__PURE__ */ new Map();
  }
  handleResize(e) {
    for (const s of e) {
      const r = this.elHandlersMap.get(s.target);
      r !== void 0 && r(s);
    }
  }
  registerHandler(e, s) {
    this.elHandlersMap.set(e, s), this.observer.observe(e);
  }
  unregisterHandler(e) {
    this.elHandlersMap.has(e) && (this.elHandlersMap.delete(e), this.observer.unobserve(e));
  }
}
const o = new i();
export {
  o as default
};
